const GET_INITIALS_VALUES = 'publicador/ducks/publish/GET_INITIALS_VALUES';
const GET_INITIALS_VALUES_FAILED = 'publicador/ducks/publish/GET_INITIALS_VALUES_FAILED';
const GET_INITIALS_VALUES_COMPLETED = 'publicador/ducks/publish/GET_INITIALS_VALUES_COMPLETED';

const GET_CREDITS_OF_BRANCH = 'publicador/ducks/publish/GET_CREDITS_OF_BRANCH';
const GET_CREDITS_OF_BRANCH_FAILED = 'publicador/ducks/publish/GET_CREDITS_OF_BRANCH_FAILED';
const GET_CREDITS_OF_BRANCH_COMPLETED = 'publicador/ducks/publish/GET_CREDITS_OF_BRANCH_COMPLETED';

const UPDATE_RESPONSIBLE = 'publicador/ducks/publish/UPDATE_RESPONSIBLE';
const UPDATE_RESPONSIBLE_FAILED = 'publicador/ducks/publish/UPDATE_RESPONSIBLE_FAILED';
const UPDATE_RESPONSIBLE_COMPLETED = 'publicador/ducks/publish/UPDATE_RESPONSIBLE_COMPLETED';

const UPDATE_BRANCH = 'publicador/ducks/publish/UPDATE_BRANCH';
const UPDATE_BRANCH_FAILED = 'publicador/ducks/publish/UPDATE_BRANCH_FAILED';
const UPDATE_BRANCH_COMPLETED = 'publicador/ducks/publish/UPDATE_BRANCH_COMPLETED';

const UPDATE_SELECTED_PLAN = 'publicador/ducks/publish/UPDATE_SELECTED_PLAN';
const UPDATE_SELECTED_RESPONSIBLE = 'publicador/ducks/publish/UPDATE_SELECTED_RESPONSIBLE';
const UPDATE_SELECTED_BRANCH = 'publicador/ducks/publish/UPDATE_SELECTED_BRANCH';
const UPDATE_COMMISSION_SHARE = 'publicador/ducks/publish/UPDATE_COMMISSION_SHARE';

const RESET_INFO = 'publicador/ducks/publish/RESET_INFO';

export {
  GET_INITIALS_VALUES,
  GET_INITIALS_VALUES_FAILED,
  GET_INITIALS_VALUES_COMPLETED,
  GET_CREDITS_OF_BRANCH,
  GET_CREDITS_OF_BRANCH_FAILED,
  GET_CREDITS_OF_BRANCH_COMPLETED,
  RESET_INFO,
  UPDATE_RESPONSIBLE,
  UPDATE_RESPONSIBLE_FAILED,
  UPDATE_RESPONSIBLE_COMPLETED,
  UPDATE_BRANCH,
  UPDATE_BRANCH_FAILED,
  UPDATE_BRANCH_COMPLETED,
  UPDATE_SELECTED_PLAN,
  UPDATE_SELECTED_RESPONSIBLE,
  UPDATE_SELECTED_BRANCH,
  UPDATE_COMMISSION_SHARE
};
